module.exports = __webpack_public_path__ + "img/phone.a36c6a00.png";